import { CookingInstructions } from "../Components/Icons";

const obj = {
  title: "Cooking Instructions",
  desc: "Provide details on your meal and get detailed cooking instructions",
  category: "Meal Planning",
  Icon: CookingInstructions,
  // tags: [],
  permissions: ["user"],

  fromColor: "gray-500",
  toColor: "gray-500",

  to: "/ai/instructions",
  api: "/ai/instructions",

  output: {
    title: "Cooking Instructions",
    desc: "Please be patient while we generate your instructions. Depending on usage it could take up to 1 minute",
    // Icon: RefreshIcon,
    // color: "",
},

  video:
    "https://mealpalaivideos.s3.ap-southeast-2.amazonaws.com/Cooking_instructions.mp4",
    prompts: [{

      title:"Meal Details",
      desc: "Please provide key information about your meal below",
      // n: 1,
      prompts: [
          { 
              title: "Meal Description", 
              attr: "mealdesc",  
              value: "", 
              placeholder: "e.g Tofu and Vegetable Stir-Fry: A classic vegan dinner, stir-fry tofu with a mix of veggies like broccoli, carrots, and snap peas, in a savory sauce made from soy sauce, rice vinegar, and ginger.", 
              // label: "Examples: breakfast, lunch, dinner, snack",
              type: "textarea",
              maxLength: 300,
              // max: 100,
              // min: 5,
              required: true,
              error: "",
              example: "Pesto pasta: pasta tossed with basil pesto, cherry tomatoes, and pine nuts.",
          },
          { 
              title: "Ingredients", 
              attr: "ingredients",  
              value: "", 
              placeholder: "may be a complete list of ingredients or otherwise a summaried version", 
              // label: "Examples: breakfast, lunch, dinner, snack",
              type: "textarea",
              maxLength: 200,
              // max: 100,
              // min: 5,
              required: false,
              error: "",
              example: "1 pound of pasta (e.g. spaghetti, linguine), 1 cup basil pesto, 1 pint of cherry tomatoes, halved 1/4 cup pine nuts, toasted, Salt and black pepper, to taste,    Grated Parmesan cheese, for serving (optional)",
          },
          { 
              title: "Dietary requirements", 
              attr: "dietary",  
              value: "", 
              placeholder: "e.g vegan, anaphylactic to nuts, ketogenic diet", 
              label: "",
              type: "textarea",
              maxLength: 100,
              // max: 100,
              // min: 1,
              required: false,
              error: "",
              example: "Gluten free"
          },
          { 
              title: "Complexity", 
              attr: "complexity",  
              value: "", 
              placeholder: "e.g keep as simple as possible, make everything from scratch", 
              label: "",
              type: "textarea",
              maxLength: 100,
              // max: 100,
              // min: 1,
              required: false,
              error: "",
              example: "Keep very simple"
          },
          { 
              title: "Special Instructions", 
              attr: "instructions",  
              value: "", 
              placeholder: "e.g units, cooking equipment, food preferences", 
              label: "",
              type: "textarea",
              maxLength: 100,
              // max: 100,
              // min: 1,
              required: false,
              error: "",
              example: "please make in australian units and it will be cooked on a standard stove"
          },

      ],
      example: {
output: `COOKING INSTRUCTIONS - Gluten-free Pesto Pasta

1. Boil water in a large pot and add salt. Cook pasta according to the package instructions until al dente. Reserve 1 cup of pasta water. Drain the pasta and set aside.
2. While the pasta is cooking, heat a pan over medium heat. Add the pine nuts and toast them until golden brown, about 2-3 minutes. Remove from heat and set aside.
3. In a large bowl, mix the cooked pasta, basil pesto, cherry tomatoes, and toasted pine nuts. Season with salt and black pepper to taste.
4. If the mixture seems too thick, add some of the reserved pasta water to loosen it up.
5. Serve the pasta immediately and top with grated Parmesan cheese, if desired.

Enjoy your delicious gluten-free Pesto Pasta!`,

          // outputs: [],
          // Icon: RefreshIcon,
          // color: "",
      }
  }]
      
}

export default obj
